import React from 'react'

import { TCustomization } from 'types/GlobalCustomization'

import Box from 'components_new/atoms/Box'
import Stack from 'components_new/atoms/Stack'
import Text from 'components_new/atoms/Text'

import Logotype from 'assets/logotypes/Logotype'

import { ThemeProvider } from '@mui/material'
import { getTheme, hexToRgbObject } from 'themes'

interface DashboardFooterProps {
  customization?: TCustomization
  scaleFactor: number
  title: string
  show: boolean
}

const DashboardFooter = (props: DashboardFooterProps) => {
  const { customization, scaleFactor, title, show } = props

  if (!show) {
    return null
  }

  const textColor = getTextColor(customization?.background_colors?.default)

  return (
    <Box
      sx={{
        height: '5%',
        width: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: '100%',
          bgcolor: customization?.background_colors?.default || 'white.main',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 4 * scaleFactor,
          overflow: 'hidden'
        }}
      >
        <ThemeProvider theme={getTheme('light')}>
          <Box sx={{ flex: 1 }}>
            <Text
              color={textColor}
              fontWeight="bold"
              fontSize={24 * scaleFactor}
              noWrap
            >
              {title}
            </Text>
          </Box>
          {customization?.logotype ? (
            <img
              src={customization.logotype}
              alt=""
              style={{
                height: 32 * scaleFactor
              }}
            />
          ) : (
            <Stack alignItems="center" sx={{ gap: 0.5 }}>
              <Text
                color="text.primary"
                fontWeight="bold"
                fontSize={12 * scaleFactor}
                lineHeight={1}
                noWrap
              >
                Powered by
              </Text>
              <Box
                role="img"
                aria-label="Homepal"
                sx={{
                  height: 32 * scaleFactor,
                  color: textColor
                }}
              >
                <Logotype />
              </Box>
            </Stack>
          )}
        </ThemeProvider>
      </Box>
    </Box>
  )
}

const getTextColor = (color: string | null | undefined) => {
  if (color) {
    const rgb = hexToRgbObject(color)
    const black = rgb.red * 0.299 + rgb.green * 0.587 + rgb.blue * 0.114 > 186

    if (black) {
      return '#0f172a'
    } else {
      return '#ffffff'
    }
  } else {
    return '#0f172a'
  }
}

export default DashboardFooter
